import {TRANSFER_SORT_OPTIONS} from '../../common/constants/Transfers.js'
import Sort from '../../common/components/List/Sort.js'
import {setSort, transferListQuerySelector} from './transferListFunctions.js'
import {useSelector} from '../../store.js'

export default function TransferSort() {
  const sort = useSelector(transferListQuerySelector).sort

  return (
    <Sort
      items={TRANSFER_SORT_OPTIONS}
      value={sort}
      onChange={(value) => setSort(value)}
    />
  )
}
